import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { NavController } from 'ionic-angular';

/**
   * Logger Factory
   * @namespace title: is the titlte od previous page
   * <ute-toolbar [title]="prevPage"></ute-toolbar>
   * --- PUT INSIDE THE ionViewDidLoad --- 
   * ionViewDidLoad() {
      if(this.navCtrl.getPrevious() !== null){
        this.prevPage = this.navCtrl.getPrevious().id;
      }
    }
*/

@Component({
  selector: 'ute-modal',
  templateUrl: 'ute-modal.component.html'
})
export class UteModalComponent  {
  @Input() icon: any;
  @Input() title: any;
  @Input() action: any;

  constructor(public navCtrl: NavController) {}


  ngOnInit(){

  }

  updateService(){
    this.navCtrl.push('dashboard');
  }

  goPreviousPage(){
    this.navCtrl.push('sim');
  }

}


// WEBPACK FOOTER //
// ./src/app/components/molecules/ute-modal/ute-modal.component.ts